export default __webpack_public_path__ + "static/media/480_store04-en-mobile.2fc2e48e.png";